import { Modal } from 'antd';
import { history } from '@umijs/max';

/**
 * Clear all authentication data from localStorage
 */
export const clearAuthData = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('currentUser');
};

/**
 * Handle token expiration with confirmation dialog
 */
export const handleTokenExpiration = () => {
  Modal.confirm({
    title: 'Session Expired',
    content: 'Your session has expired. Please log in again to continue.',
    okText: 'Log In',
    cancelText: 'Cancel',
    onOk: () => {
      // Clear all authentication data
      clearAuthData();
      // Redirect to login page
      history.push('/user/login');
    },
    onCancel: () => {
      // User cancelled, but we still need to clear the tokens
      // and redirect to prevent further API calls with invalid tokens
      clearAuthData();
      history.push('/user/login');
    },
  });
};

/**
 * Check if user is authenticated
 */
export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('access_token');
  const userData = localStorage.getItem('currentUser');
  return !!(token && userData);
};

/**
 * Get current user data from localStorage
 */
export const getCurrentUser = () => {
  const userData = localStorage.getItem('currentUser');
  if (userData) {
    try {
      return JSON.parse(userData);
    } catch (error) {
      // If parsing fails, clear the corrupted data
      localStorage.removeItem('currentUser');
      return null;
    }
  }
  return null;
};
